import { WorkScheduleActionTypes } from "./constants";

export const workScheduleApiResponseSuccess = ( actionType = '', data = {} ) => ({
  type: WorkScheduleActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const workScheduleApiResponseError = ( actionType = '', error = '' ) => ({
  type: WorkScheduleActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getWorkScheduleList = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST,
    payload: { params },
  }
};

export const getWorkScheduleShiftNameList = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_SHIFT_NAME_LIST,
    payload: { params },
  }
};

export const getWorkScheduleByDayOfWeekList = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_BY_DAY_OF_WEEK_LIST,
    payload: { params },
  }
};

export const getWorkScheduleByDay = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_BY_DAY,
    payload: { params },
  }
};

export const getWorkScheduleOption = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_OPTION,
    payload: { params },
  }
};

export const getWorkScheduleByShift = (params) => {
  return {
    type: WorkScheduleActionTypes.GET_WORK_SCHEDULE_BY_SHIFT,
    payload: { params }
  }
};

export const resetWorkScheduleList = () => {
  return {
    type: WorkScheduleActionTypes.RESET_WORK_SCHEDULE_LIST,
    payload: {},
  }
};

export const resetWorkScheduleShiftNameList = () => {
  return {
    type: WorkScheduleActionTypes.RESET_WORK_SCHEDULE_SHIFT_NAME_LIST,
    payload: {},
  }
};